import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import moment from 'moment';
import {PageEvent} from '@angular/material/paginator';
import {removeEmptyParams} from "../../../../infrastructure/helper/remove-empty-params";
import {ITmtErpOutboundGroupedResponse} from '../interfaces/tmt-erp-outbound-panel.interface';
import {TmtErpOutboundPanelFilterService} from './tmt-erp-outbound-panel-filter.service';

@Injectable({
  providedIn: 'root',
})
export class TmtErpOutboundReportGroupedService {
  private readonly baseUrl = 'tmt/sales-order-erp-responses/grouped-by-order';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(TmtErpOutboundPanelFilterService);

  getGroups(page?: Partial<PageEvent>): Observable<ITmtErpOutboundGroupedResponse> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      invoiceNumber: filters?.InvoiceNumber ?? '',
      pnr: filters?.PNR ?? '',
      erpMessageId: filters?.ErpMessageId ?? '',
      erpOrderNumber: filters?.ErpOrderNumber ?? '',
      legalEntityId: filters?.LegalEntityId ?? '',
      queueName: filters?.QueueName ?? '',
      responseType: filters?.ResponseType ?? '',
      result: filters?.Result ?? '',
      createdDateFrom: filters?.CreatedDateFrom ? moment(filters.CreatedDateFrom).format('YYYY-MM-DD') : '',
      createdDateTo: filters?.CreatedDateTo ? moment(filters.CreatedDateTo).format('YYYY-MM-DD') : '',
      salesOrderSyncQueueId: filters?.SalesOrderSyncQueueId ?? '',
      hasSalesOrderNumber: filters?.HasSalesOrderNumber ?? '',
      hasSalesOrderSyncQueueId: filters?.HasSalesOrderSyncQueueId ?? ''
    };

    removeEmptyParams(params);

    return this.http.get<ITmtErpOutboundGroupedResponse>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
